<template>
<div>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row content-add-btn padbtn">
          <div class="col-4" v-if="canCreate()">
            <button class="btn btn-secondary btn-fg custom-shadow-btn" @click="$router.push('/modules/create')">
              <i class="fa fa-plus"></i>
              Agregar Modulo
            </button>
          </div>
        </div>
        <hr>
        <div class="row">
          <div class="col-12 text-center">
            <h6 class="text-muted">Modulos Activos</h6>
          </div>
        </div>
        <div v-if="canIndex()">
          <div class="col-12">
            <div class="row">
              <div class="col-6 col-sm-4 col-md-6">
                <el-select
                  class="select-default mb-3"
                  v-model="pagination.perPage"
                  placeholder="Por pagina">
                  <el-option
                  class="select-default"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item">
                  </el-option>
                </el-select>
              </div>
              <div class="col-6 col-sm-4 col-md-3">
                <div class="mr-1 pull-right" v-if="canPDF()">
                  <img
                    class="img-exports"
                    src="/static/img/icons/docs/pdf.svg"
                    alt="pdf"
                    v-tooltip="'Exportar en formato PDF'"
                    @click="exportPDF('modulos', 'Modulos', 'a3', tableData, tableColumnsAll, 1)">
                </div>
                <div class="mr-1 pull-right" v-if="canExcel()">
                    <img
                      class="img-exports"
                      src="/static/img/icons/docs/xls.svg"
                      alt="xls"
                      v-tooltip="'Exportar en formato XLSX'"
                      @click="exportExcel('modulos', tableData, tableColumnsAll, 1)">
                </div>
                <div class="mr-1 pull-right" v-if="canCSV()">
                  <img
                    class="img-exports"
                    src="/static/img/icons/docs/csv.svg"
                    alt="csv"
                    v-tooltip="'Exportar en formato CSV'"
                    @click="exportCSV('modulos', tableData, tableColumnsAll, 1)">
                </div>
              </div>
              <div class="col-6 col-sm-4 col-md-3">
                <el-input
                class="mb-3"
                placeholder="Buscar registros"
                v-model="searchQuery"
                aria-controls="datatables"/>
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <el-table
                      style="width: 100%;"
                      :data="queriedData"
                      border
                      ref="tableModule">
              <el-table-column type="index" width="65"></el-table-column>
              <el-table-column v-for="column in tableColumns"
                               :key="column.label"
                               :min-width="column.minWidth"
                               :prop="column.prop"
                               :label="column.label">
              </el-table-column>
              <el-table-column
                :min-width="120"
                fixed="right"
                label="Acciones">
                <template slot-scope="props">
                  <a v-if="canShow()" v-tooltip.top-center="'Ver'" class="btn-info btn-simple btn-link"
                     @click="handleView(props.$index, props.row)">
                    <i class="fa fa-eye"></i></a>
                  <a v-if="canRoles()" v-tooltip.top-center="'Asociar Perfiles'" class="btn-primary btn-simple btn-link"
                     @click="handleRoles(props.$index, props.row)"><i
                    class="fa fa-tags"></i></a>
                  <a v-if="canUpdate()" v-tooltip.top-center="'Editar'" class="btn-warning btn-simple btn-link"
                     @click="handleEdit(props.$index, props.row)"><i
                    class="fa fa-edit"></i></a>
                  <a v-if="canDelete()" v-tooltip.top-center="'Borrar'" class="btn-danger btn-simple btn-link"
                     @click="handleDelete(props.$index, props.row)"><i class="fa fa-times"></i></a>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-else>
          <div class="text-center">
            <h4> <strong> No tienes permiso para indexar información </strong></h4>
          </div>
        </div>
        <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
          <div class="">
            <p class="card-category">Mostrando {{from + 1}} a {{to}} de {{total}} entradas</p>
          </div>
          <l-pagination class="pagination-no-border"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="pagination.total">
          </l-pagination>
        </div>
      </card>
    </div>
  </div>
  <div class="row">
    <el-dialog v-if="canShow()"
      :title="title"
      :visible.sync="modals.read">
        <p>A continuación encontrarás toda la información asociada al registro seleccionado.</p>
      <div class="card" v-if="rowData">
        <div class="card-body">
          <table class="table">
            <tbody v-if="rowData">
              <tr class="shadow-sm">
                <td scope="row">
                  <h6><b>Nombre:</b></h6>
                  {{rowData.name_module}}
                </td>
              </tr>
              <tr class="shadow-sm">
                <td scope="row">
                  <h6><b>URL:</b></h6>
                  {{rowData.url}}
                </td>
              </tr>
              <tr class="shadow-sm">
                <td scope="row">
                  <h6><b>Icono:</b></h6>
                  {{rowData.icon}}
                </td>
              </tr>
              <tr class="shadow-sm">
                <td scope="row">
                  <h6><b>Descripción:</b></h6>
                  {{rowData.description}}
                </td>
              </tr>
              <tr class="shadow-sm">
                <td scope="row">
                  <h6><b>Orden:</b></h6>
                  Orden {{rowData.order}}
                </td>
              </tr>
              <tr class="shadow-sm">
                <td scope="row">
                  <h6><b>Nivel:</b></h6>
                  Nivel {{rowData.level}}
                </td>
              </tr>
              <tr class="shadow-sm">
                <td scope="row">
                  <h6><b>Modulo Padre:</b></h6>
                  {{rowData.parent_label}}
                </td>
              </tr>
              <tr class="shadow-sm">
                <td scope="row">
                  <h6 class="custom-margin-h6-table"><b>Perfiles:</b></h6>
                  <template v-for="(role, index) in rowData.roles">
                    <el-tag :key="role.id"
                      size="small"
                      type="success"
                      :closable="false"
                      :close-transition="false">
                        {{role.name}}
                    </el-tag>
                    <br :key="index+'Index'" v-if="(((index+1) % 4) == 0)"/>
                  </template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="card-footer footer-date-at" v-if="rowData">
          <p class="text-muted"><small>Creado el: {{rowData.created_at}}</small></p>
        </div>
      </div>
    </el-dialog>
    <el-dialog v-if="canRoles()"
      :title="title"
      :visible.sync="modals.roles">
      <span>A continuación seleccione los perfiles a asociar con el modulo:</span><br><br>
      <el-select  multiple class="select-primary select_modules"
      v-model="moduleForm.roles"
      filterable placeholder="Seleccione uno o varios Perfiles">
        <el-option v-for="option in roles"
                    class="select-primary"
                    :value="option.id"
                    :label="option.name"
                    :key="option.name">
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <button class="btn btn-danger" @click="closeModal('roles')">Cancelar</button>&nbsp;
        <button class="btn btn-success" @click="addOrDeleteRol()">Confirmar</button>
      </span>
    </el-dialog>
  </div>
</div>
</template>
<script>
  import mixinMasters from 'src/util/mixinMasters'
  import mixinPermissions from 'src/util/mixinPermissions'
  import showSwalAlert from 'src/util/alerts'
  import table from './moduleTable'
  import moment from 'moment';

  export default {
    data () {
      return {
        moduleForm: {
          name_module: null,
          url: null,
          icon: null,
          description: null,
          order: null,
          level: null,
          parent_module: null,
          roles: null
        },
        roles: null,
        modals: {
          roles: false
        },
        tableColumns: table[0],
        tableColumnsAll: table,
      }
    },
    mixins: [mixinMasters, mixinPermissions],
    methods: {
      handleView (index, row) {
        this.rowData = Object.assign({}, row)
        this.rowData.created_at = moment(String(this.rowData.created_at)).format('MM/DD/YYYY hh:mm:ss')
        this.title = 'Modulo '+this.rowData.name_module
        this.modals['read'] = true
      },
      handleEdit (index, row) {
        this.moduleForm = Object.assign({}, row)
        this.moduleForm.roles = row.roles_ids
        localStorage.setItem( 'moduleEdit', JSON.stringify(this.moduleForm) )
        this.$router.push({ name: 'Editar Modulo' });
      },
      handleRoles (index, row) {
        this.moduleForm = Object.assign({}, row)
        this.moduleForm.roles = row.roles_ids
        this.title = 'Gestionar Perfiles de '+row.name_module
        this.modals['roles'] = true
      },
      handleDelete (index, row) {
        this.moduleForm = Object.assign({}, row)
        this.moduleForm.roles = row.roles_ids
        showSwalAlert('Modulo', 'delete', true, null, 'modulo: '+row.name_module).then((result) => {
          if (result.value) this.deleteModule()
        })
      },
      deleteModule(){
        this.$emit('cotentLoading', true)
        this.moduleForm.route = 'modules'
        this.destroyMaster(this.moduleForm)
          .then((response) => this.modifyTable(2, this.moduleForm.id, response))
          .catch((error) => this.showMessageErrors(error))
      },
      addOrDeleteRol(){
        this.$emit('cotentLoading', true)
        this.moduleForm.route = 'modules/roles'
        this.saveMaster(this.moduleForm)
          .then((response) => this.modifyTable(3, this.moduleForm.id, response, 'roles'))
          .catch((error) => this.showMessageErrors(error))
      },
    },
    created(){
      if(this.canIndex()){
        this.getMasters('modules').then((response) => {
          this.tableData = response.data.data
          this.searchFuse(['name_module', 'url', 'type'])
          this.$emit('cotentLoading')
        }).catch((error) => this.showMessageErrors(error))
        this.getMasters('roles/index')
          .then((response) => this.roles = response.data.data)
          .catch((error) => this.showMessageErrors(error))
      }
    },
  }
</script>
<style>
</style>
